export const StatBar = ({ label, value, max = 100, tone = "primary" }) => {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  const bar = tone === "secondary" ? "bg-secondary" : tone === "green" ? "bg-green-600"
    : tone === "amber" ? "bg-amber-500" : "bg-primary";
  return (
    <div data-testid={`stat-${label.toLowerCase().replace(/\s/g, "-")}`}>
      <div className="mb-0.5 flex items-center justify-between text-[11px] font-semibold">
        <span className="text-muted-foreground">{label}</span>
        <span className="text-primary">{Math.round(value)}</span>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-muted">
        <div className={`h-full rounded-full ${bar} transition-all duration-500`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};
